
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleet as ObiLightSleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet.js';
 
 
 

 
 export const ObiLightSleet = createComponent({
   react: React,
   tagName: 'obi-light-sleet',
   elementClass: ObiLightSleetElement,
   events: {
     
   }
  });
 
 